module.exports = __webpack_public_path__ + "img/try2.0c6f91cf.png";